import { red } from '@material-ui/core/colors';
import { createMuiTheme } from '@material-ui/core/styles';

const darkBlue = getComputedStyle(document.documentElement).getPropertyValue('--darkBlue');
// A custom theme for this app
const theme = createMuiTheme({
    breakpoints: {
        values: {
            xs: 0,
            sm: 600,
            md: 960,
            lg: 1180,
            xl: 1920,
        },
    },
  palette: {
    primary: {
          main: '#001641',
    },
    secondary: {
        main: '#001641',
    },
    danger: {
        main: "#ED0A00",
    },
    error: {
        main: "#ED0A00",
    },
    background: {
        default: 'var(--white)',
      },      
  },
});


export default theme;